export interface SizeProperties {
  width?: number;
  height?: number;
  opacity?: number;
  onComplete?: Function;
}

export const AnimationDuration = 200;
